import React from 'react';
import { Row, Col, Card, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';

const TagsAnalysisSection = ({ 
  selectedReport, 
  sectionVisibility 
}) => {
  if (!sectionVisibility.tagsAnalysis) return null;

  return (
    <Row className="mb-4">
      <Col md={12}>
        <Card className="shadow-sm report-card">
          <Card.Header className="bg-light">
            <h6 className="mb-0">
              <FontAwesomeIcon icon={faTag} className="me-2" />
              Analiza tagów urządzeń
            </h6>
          </Card.Header>
          <Card.Body>
            {selectedReport.data?.tagsCountByDevType?.length > 0 ? (
              <div style={{maxHeight: '400px', overflowY: 'auto'}}>
                {/* Group tags by tag name and aggregate device types */}
                {(() => {
                  // Group tags by tag name
                  const tagGroups = selectedReport.data.tagsCountByDevType.reduce((acc, tag) => {
                    if (!acc[tag.tag_name]) {
                      acc[tag.tag_name] = {
                        tagName: tag.tag_name,
                        totalCount: 0,
                        deviceTypes: []
                      };
                    }
                    acc[tag.tag_name].totalCount += tag.count;
                    acc[tag.tag_name].deviceTypes.push({
                      dev_type: tag.dev_type,
                      count: tag.count
                    });
                    return acc;
                  }, {});

                  // Sort by total count descending
                  const sortedTagGroups = Object.values(tagGroups)
                    .sort((a, b) => b.totalCount - a.totalCount);

                  return sortedTagGroups.map((tagGroup, index) => (
                    <div key={index} className="mb-4 p-3 border rounded bg-light">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0 text-primary">
                          <FontAwesomeIcon icon={faTag} className="me-2" />
                          {tagGroup.tagName}
                        </h6>
                        <Badge bg="primary" className="px-3 py-2 fs-6">
                          {tagGroup.totalCount} urządzeń
                        </Badge>
                      </div>
                      
                      {/* Device types breakdown */}
                      <div className="row">
                        {tagGroup.deviceTypes
                          .sort((a, b) => b.count - a.count) // Sort device types by count descending
                          .map((deviceType, dtIndex) => (
                          <div key={dtIndex} className="col-md-3 col-sm-6 mb-2">
                            <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-white">
                              <div>
                                <Badge bg="secondary" className="small">
                                  {deviceType.dev_type}
                                </Badge>
                              </div>
                              <div className="fw-bold text-end">
                                <span className="h6 mb-0">{deviceType.count}</span>
                                <div className="small text-muted">
                                  {((deviceType.count / tagGroup.totalCount) * 100).toFixed(1)}%
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      
                      {/* Progress bar showing distribution */}
                      <div className="mt-2">
                        <div className="d-flex">
                          {tagGroup.deviceTypes
                            .sort((a, b) => b.count - a.count)
                            .map((deviceType, dtIndex) => {
                              const percentage = (deviceType.count / tagGroup.totalCount) * 100;
                              const colors = ['#007bff', '#6c757d', '#28a745', '#ffc107', '#dc3545', '#17a2b8', '#6f42c1', '#fd7e14'];
                              return (
                                <div
                                  key={dtIndex}
                                  style={{
                                    width: `${percentage}%`,
                                    height: '8px',
                                    backgroundColor: colors[dtIndex % colors.length],
                                    borderRadius: dtIndex === 0 ? '4px 0 0 4px' : 
                                                dtIndex === tagGroup.deviceTypes.length - 1 ? '0 4px 4px 0' : '0'
                                  }}
                                  title={`${deviceType.dev_type}: ${deviceType.count} (${percentage.toFixed(1)}%)`}
                                />
                              );
                            })}
                        </div>
                        <div className="d-flex justify-content-between mt-1">
                          <small className="text-muted">Rozkład według typów urządzeń</small>
                          <small className="text-muted">
                            {tagGroup.deviceTypes.length} {tagGroup.deviceTypes.length === 1 ? 'typ' : 'typy'}
                          </small>
                        </div>
                      </div>
                    </div>
                  ));
                })()}
              </div>
            ) : (
              <div className="text-center p-4 text-muted">
                <FontAwesomeIcon icon={faTag} size="2x" className="mb-2" />
                <p className="mb-0">Brak danych o tagach urządzeń</p>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default TagsAnalysisSection;